import * as Dialog from '@radix-ui/react-dialog';
import clsx from 'clsx';
import type { ModalProps } from './types';
import './Modal.scss';

export default function Modal({
  open,
  onOpenChange,
  children,
  className,
  returnFocusRef,
}: ModalProps) {
  return (
    <Dialog.Root open={open} onOpenChange={onOpenChange}>
      <Dialog.Portal>
        <Dialog.Overlay className={clsx('bio-modal', className)}>
          <Dialog.Content
            className="bio-modal__dialog"
            aria-describedby={undefined}
            onCloseAutoFocus={() => returnFocusRef?.current?.focus()}
          >
            <div className="bio-modal__content">{children}</div>
          </Dialog.Content>
        </Dialog.Overlay>
      </Dialog.Portal>
    </Dialog.Root>
  );
}
